import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './17-synthography.mp3';

const transcript = `
  Ik zal beginnen met uitleggen wat synthografie is, aangezien dit een nieuw beroep is in het AI-tijdperk.

  Synthografie komt van de woorden "synthetisch," wat kunstmatig of door technologie gecreëerd betekent, en grafie, 
  dat staat voor het vastleggen of beschrijven van iets, zoals bij fotografie.

  Het is een creatief proces waarbij AI wordt ingezet om volledig nieuwe beelden te genereren die niet in de fysieke 
  wereld bestaan. Dit opent de deur naar unieke visuele mogelijkheden en biedt een krachtig hulpmiddel voor 
  creatievelingen en bedrijven om ideeën tot leven te brengen.

  Jonathan, zou jij hier nog iets aan willen toevoegen voordat we uitleggen hoe dit werkt?
`;

// Jonathan: Nee, dat is goed voor nu. Maar misschien eerst wat laten zien?

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="bottom-right" networkBackground="full">
      <div className="slide relative z-10">
        <h1>
          Wat is <u>Synthografie</u>?
        </h1>
        <div className="text-left space-y-4">
          <WebContent
            animation={{
              type: 'fade',
              delay: 2000,
              duration: 800,
            }}
          >
            <p>Een nieuw beroep in het AI-tijdperk</p>
          </WebContent>
          <ul className="list-disc list-inside space-y-2">
            <WebContent
              animation={{
                type: 'fade',
                delay: 7000,
                duration: 800,
              }}
            >
              <li>Van "synthetisch" (kunstmatig) en "grafie" (vastleggen)</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 21000,
                duration: 800,
              }}
            >
              <li>Creatief proces met AI-technologie</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 25000,
                duration: 800,
              }}
            >
              <li>Genereert beelden die niet fysiek bestaan</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 28000,
                duration: 800,
              }}
            >
              <li>Biedt unieke visuele mogelijkheden</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 32000,
                duration: 800,
              }}
            >
              <li>Krachtig hulpmiddel voor creatie en innovatie</li>
            </WebContent>
          </ul>
        </div>
      </div>
    </Slide>
  );
};
